export default __webpack_public_path__ + "static/media/aceinna-logo.09324eef.png";